<div class="image" (click)="lightbox()">
  <img [src]="photos[activeIndex].medium_url" class="img" alt="Product Image" title="">
  <span *ngIf="photos[activeIndex].overlay_url" class="overlay-image" [ngStyle]="{ 'background': getOverlayStyle(), 'background-size': 'contain' }"></span>
</div>

<div class="images" *ngIf="photos.length > 1">
  <div class="mini-image-wrapper" *ngFor="let photo of photos; let i = index;" (mouseenter)="activeIndex = i" (click)="lightbox()">
    <img class="mini-image light-disabled-border-color hover-accent-border-color" [ngClass]="{ 'accent-border-color': activeIndex == i }" [src]="photo.thumbnail_url">
  </div>
</div>